class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = '';

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  async onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    console.log('update');

    const freebieID = 42018339323991
    const hasFreeItemId = Number(document.querySelector('[headers="CartDrawer-ColumnProduct"] .cart-item__name:not([ismainitem])')?.dataset?.variantId) || false;
    const isLastMainItem = document.querySelectorAll('[headers="CartDrawer-ColumnProduct"] .cart-item__name[ismainitem]').length;
    const mainProductVariantId = Number(document.querySelector('[headers="CartDrawer-ColumnProduct"] .cart-item__name[ismainitem]').dataset.variantId);
    console.log('hasFreeItemId',hasFreeItemId)
    if(isLastMainItem == 1 && quantity == 0 && hasFreeItemId){
      removeFreeProduct(freebieID, mainProductVariantId)
      return;
    }
    
    if(hasFreeItemId && isLastMainItem == 0){
      removeFreeProduct(freebieID)
      return;
    }

    $('#CartDrawer-Checkout').attr("disabled",true);
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then(async (state) => {
        let parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
        // await updateProduct(42018339323991);        
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        window.addSlickSlider();
        window.cart_more_addSlickSlider();
        window.removeAddonProduct();
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

function removeFreeProduct(freeId, mainId){
  let updates;
  if(freeId && mainId){
    updates = {
      [freeId] : 0,
      [mainId] : 0
    }
  }
  else if(freeId){
    updates = {
      [freeId]: 0
    }
  }
  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      updates: updates,
      sections: ['cart-drawer', 'cart-icon-bubble']
    })
  })
  .then(resp => resp.json())
  .then(result => {
    const parse = new DOMParser();
    const oldCartDrawer = document.querySelector('cart-drawer');
    const oldCartIconBubble = document.querySelector('#cart-icon-bubble');
    const newCartDrawer = parse.parseFromString(result.sections['cart-drawer'], 'text/html').querySelector('.shopify-section').querySelector('cart-drawer');
    const newCartIconBubble = parse.parseFromString(result.sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');

    if(newCartDrawer && oldCartDrawer) oldCartDrawer.innerHTML = newCartDrawer.innerHTML;
    if(newCartIconBubble && oldCartIconBubble) oldCartIconBubble.innerHTML = newCartIconBubble.innerHTML;
    document.querySelector('cart-drawer').classList.toggle('is-empty',result.item_count == 0);
  })
}

// updateProduct = async (id, main_id) => {
//   let quantity = 0;
//   let freeItemId = Number(id);
//   let mainItemId = Number(main_id);
//   const getCart = await fetch('/cart.js');
//   const cartData = await getCart.json();

//   const isFreeItemInCart = cartData.items.some(item => item.id === freeItemId);
//   const hasOtherItemInCart = cartData.items.some(item => item.id !== freeItemId);

//   if(hasOtherItemInCart && isFreeItemInCart) return;
//   if(hasOtherItemInCart && !isFreeItemInCart) quantity = 1;

//   const updateResp = await fetch('/cart/update.js',{
//     method: 'POST',
//     headers:{
//       "Content-Type": "application/json"
//     },
//     body: JSON.stringify({
//       updates: {
//         [freeItemId]:quantity,
//         [mainItemId]: 1
//       },
//       sections: ["cart-drawer", 'cart-icon-bubble']
//     })
//   })
//   if(!updateResp.ok){
//     throw new Error('Falied To Add Freebie Item.')
//   }
//     const cart__Data = await updateResp.json();
//     const parse = new DOMParser();
//     const oldCartDrawer = document.querySelector('cart-drawer');
//     const oldCartIconBubble = document.querySelector('#cart-icon-bubble');
//     const newCartDrawer = parse.parseFromString(cart__Data.sections['cart-drawer'], 'text/html').querySelector('.shopify-section').querySelector('cart-drawer');
//     const newCartIconBubble = parse.parseFromString(cart__Data.sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');

//     if(newCartDrawer && oldCartDrawer) oldCartDrawer.innerHTML = newCartDrawer.innerHTML;
//     if(newCartIconBubble && oldCartIconBubble) oldCartIconBubble.innerHTML = newCartIconBubble.innerHTML;
//     document.querySelector('cart-drawer').classList.toggle('is-empty',cart__Data.item_count == 0);
// }

window.removeAddonProduct = async function () {
  try {
    tC(1)
    // Build addon ID list from globals (ensure numeric)
    const addonIds = [window.addon_product, window.addon_product_2, '42653831495767']
      .filter(Boolean)
      .map(id => parseInt(id, 10));

      console.log(addonIds,'addonIds>>>',window.addon_product_2);
    if (addonIds.length === 0) {
      console.log('No addon product IDs defined.');
      return;
    }

    // Fetch current cart
    const cartResponse = await fetch('/cart.js');
    if (!cartResponse.ok) {
      console.error('Failed to fetch cart:', cartResponse.statusText);
      return;
    }
    const cart = await cartResponse.json();

    // If cart is empty nothing to do
    if (!cart.items || cart.items.length === 0) {
      console.log('Cart is empty.');
      return;
    }

    // Check whether ALL items in cart are addon items
    const allItemsAreAddons = cart.items.every(item => {
      return addonIds.includes(parseInt(item.id, 10));
     
    });

    if (!allItemsAreAddons) {
      console.log('Cart has other items. Addon products not removed.');
       $('.cart__checkout-button').attr('disabled', false);
       tC(0)
      return;
    }

    // Prepare updates: set each addon line-item id to 0
    const formData = { updates: {} };
    cart.items.forEach(item => {
      if (addonIds.includes(parseInt(item.id, 10))) {
        formData.updates[item.id] = 0;
      }
    });

    // If nothing to update, exit
    if (Object.keys(formData.updates).length === 0) {
      console.log('No matching addon line items to remove.');
      return;
    }

    // Send update request
    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData)
    });

    if (response.ok) {
      const updatedCart = await response.json();
      console.log('Updated cart:', updatedCart);

      // Refresh UI (delay to let shopify backend finish)
      setTimeout(function() {
        if (typeof window.refreshCart === 'function') window.refreshCart();
        // re-enable checkout button if you previously disabled it
        const $btn = $('.cart__checkout-button');
        if ($btn && $btn.length) $btn.attr('disabled', false);
        tC(0)
      }, 1000);
    } else {
      console.error('Failed to update cart:', response.statusText);
    }
  } catch (error) {
    console.error('Error removing items:', error);
  }
};


